/**
 * Una riga dei voti (V15, V27), a card come le righe della rosa: la maglia,
 * il nome, una riga di dettaglio che durante il salvataggio lascia il posto
 * al suo esito, e il selettore da 1 a 10 a mezzi punti con "—" per togliere
 * il voto. Chi non scrive vede il voto nel badge del suo colore.
 */

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { RuoloGiocatore } from '@calcio/shared';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { coloreVoto } from '../giocatori/colori-stato.js';
import { VALORI_SCALA } from '../giocatori/elenchi.js';
import type { EsitoRiga } from './coda.js';
import { Maglia } from './Maglia.js';

/** Valore del selettore per "nessun voto": Radix non accetta la stringa vuota. */
const NESSUNO = 'nessuno';

export function RigaVoto({
  numero,
  ruolo,
  nome,
  dettaglio,
  esito,
  valore,
  scrive,
  onCambio,
}: {
  numero: number | null;
  ruolo: RuoloGiocatore | null;
  /** Cognome e nome. */
  nome: string;
  dettaglio: string;
  esito: EsitoRiga;
  valore: number | null;
  scrive: boolean;
  onCambio: (valore: number | null) => void;
}) {
  return (
    <li className="flex items-center gap-3 rounded-lg border border-border bg-card p-2">
      <Maglia numero={numero} ruolo={ruolo} />
      <div className="flex min-w-0 flex-1 flex-col">
        <span className="truncate font-semibold">{nome}</span>
        <span
          className={cn(
            'truncate text-[13px]',
            esito === 'non_salvato' ? 'font-semibold text-destructive' : 'text-muted-foreground',
          )}
        >
          {esito === 'invio' ? 'Salvo…' : esito === 'non_salvato' ? 'Non salvato' : dettaglio}
        </span>
      </div>
      {scrive ? (
        <Select
          value={valore === null ? NESSUNO : String(valore)}
          onValueChange={(v) => onCambio(v === NESSUNO ? null : Number(v))}
        >
          <SelectTrigger className="w-20 tabular-nums" aria-label={`Voto ${nome}`}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              <SelectItem value={NESSUNO}>—</SelectItem>
              {VALORI_SCALA.map((v) => (
                <SelectItem key={v} value={String(v)}>
                  {v.toLocaleString('it-IT')}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      ) : valore !== null ? (
        <Badge className={cn('tabular-nums', coloreVoto(valore))}>
          {valore.toLocaleString('it-IT')}
        </Badge>
      ) : (
        <span className="px-2 text-muted-foreground">—</span>
      )}
    </li>
  );
}
